cc.Class({
    extends: cc.Component,

    properties: {
        skeleton: sp.Skeleton,
        boneName: cc.String,
        active: true
    },

    start () {
        this.originalRotation = -this.node.angle;
        this.bone = this.skeleton.findBone(this.boneName);
    },

    /**
     * Enables or disables the bone following. Useful if we want to manually set the position of the node or we don't want it
     * to follow the bone offscreen.
     * @param {boolean} [should=true] Tells the method if it should enable or disable the bone following.
     */
    enable (should = true) {
        if (should) {
            this.active = true;
        } else {
            // we want to set the original rotation in case the bone following stoped when bone was rotated
            this.node.angle = -this.originalRotation;
            this.active = false;
        }
    },

    /**
     * Called by Cocos on every frame when the component is active.
     */
    update () {
        if (this.active === true) {
            // we have to check if the node is a child. If it is the scale is already applied to it through the hiearchy
            // and we should not do it again. However it is not a child then we have to apply the scale.
            if (this.node.isChildOf(this.skeleton.node)) {
                this.node.setPosition(this.bone.worldX, this.bone.worldY);
            } else {
                this.node.setPosition(this.bone.worldX * this.skeleton.node.scaleX, this.bone.worldY * this.skeleton.node.scaleY);
            }
            this.node.angle = this.bone.getWorldRotationX();
        }
    }
});
